import React from "react";
import { Show, SimpleShowLayout, SelectField, TextField, DateField, RichTextField, BooleanField } from "react-admin";
import { dateOptions, languageChoices, positionType } from "../../../utils/options";
import { minContainer } from "customStyles/ra-custom-styles";

const ShowVacantPositions = () => {
  return (
    <Show title="Детайли на свободна позиция">
      <SimpleShowLayout sx={minContainer}>
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <TextField
          label="Заглавие"
          source="title"
          multiline
        />
        <DateField
          label="Дата на публикуване"
          source="starting_on"
          locales={"bg"}
          options={dateOptions}
        />
        <TextField
          label="Населено място"
          source="inhabited_area"
          multiline
        />
        <SelectField
          label="Тип"
          source="type"
          choices={positionType}
        />
        <RichTextField
          label="Съдържание"
          source="content"
          multiline
        />
        <BooleanField
          label="Скрита"
          source="is_hidden"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowVacantPositions;
